import { useContext } from "react";
import { SubscriptionIdContext } from "../context/Contexts";

export const useSubscriptionId = () => useContext(SubscriptionIdContext) || {};

